/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AbstractCommand } from '../AbstractCommand';
import { ModelUtils } from '../util/ModelUtils';
import { NodeCompat } from '../../compat/NodeCompat';
import { DocumentType } from '../../core/models/DocumentType';
import { OasSchema } from '../../openapi/models/OasSchema';
import { Oas30Schema } from '../../openapi/v3/models/Oas30Schema';

/**
 * @author eric.wittmann@gmail.com
 * @class
 * @extends AbstractCommand
 */
export abstract class AbstractSchemaInhCommand extends AbstractCommand {
    public static TYPE_NONE : string = "none";

    public static TYPE_ALL_OF : string = "allOf";

    public static TYPE_ONE_OF : string = "oneOf";

    public static TYPE_ANY_OF : string = "anyOf";

    /**
     * Determines the current inheritance type for the given schema.
     * @param {OasSchema} schema
     * @return {string}
     */
    static getInheritanceType(schema : OasSchema) : string {
        if(ModelUtils.isDefined(schema.allOf)) {
            return AbstractSchemaInhCommand.TYPE_ALL_OF;
        }
        if(schema.ownerDocument().getDocumentType() === DocumentType.openapi3) {
            let schema30 : Oas30Schema = <Oas30Schema>schema;
            if(ModelUtils.isDefined(schema30.anyOf)) {
                return AbstractSchemaInhCommand.TYPE_ANY_OF;
            }
            if(ModelUtils.isDefined(schema30.oneOf)) {
                return AbstractSchemaInhCommand.TYPE_ONE_OF;
            }
        }
        return AbstractSchemaInhCommand.TYPE_NONE;
    }

    /**
     * Creates a schema of a particular type (allOf, anyOf, etc).
     * @param {OasSchema} parentSchema
     * @param {string} inheritanceType
     * @return {OasSchema}
     */
    createSchema(parentSchema : OasSchema, inheritanceType : string) : OasSchema {
        if(NodeCompat.equals(AbstractSchemaInhCommand.TYPE_ALL_OF, inheritanceType)) {
            return parentSchema.createAllOfSchema();
        }
        if(NodeCompat.equals(AbstractSchemaInhCommand.TYPE_ANY_OF, inheritanceType)) {
            let schema30 : Oas30Schema = <Oas30Schema>parentSchema;
            return schema30.createAnyOfSchema();
        }
        if(NodeCompat.equals(AbstractSchemaInhCommand.TYPE_ONE_OF, inheritanceType)) {
            let schema30 : Oas30Schema = <Oas30Schema>parentSchema;
            return schema30.createOneOfSchema();
        }
        return parentSchema.createAllOfSchema();
    }

    /**
     * Copies the given list of schemas to the appropriate property on the model
     * @param {*[]} schemas
     * @param {OasSchema} targetSchema
     * @param {string} inheritanceType
     */
    copySchemaJsTo(schemas : Array<any>, targetSchema : OasSchema, inheritanceType : string) {
        if(NodeCompat.equals(AbstractSchemaInhCommand.TYPE_ALL_OF, inheritanceType)) {
            schemas.forEach((ser) => {
                targetSchema.addAllOfSchema(<OasSchema>Library.readNode(ser, targetSchema.createAllOfSchema()));
            });
        }
        if(NodeCompat.equals(AbstractSchemaInhCommand.TYPE_ANY_OF, inheritanceType)) {
            let targetSchema30 : Oas30Schema = <Oas30Schema>targetSchema;
            schemas.forEach(((targetSchema30) => {
                return (ser) => {
                    targetSchema30.addAnyOfSchema(<Oas30Schema.Oas30AnyOfSchema>Library.readNode(ser, targetSchema30.createAnyOfSchema()));
                }
            })(targetSchema30));
        }
        if(NodeCompat.equals(AbstractSchemaInhCommand.TYPE_ONE_OF, inheritanceType)) {
            let targetSchema30 : Oas30Schema = <Oas30Schema>targetSchema;
            schemas.forEach(((targetSchema30) => {
                return (ser) => {
                    targetSchema30.addOneOfSchema(<Oas30Schema.Oas30OneOfSchema>Library.readNode(ser, targetSchema30.createOneOfSchema()));
                }
            })(targetSchema30));
        }
    }

    constructor() {
        super();
    }
}
AbstractSchemaInhCommand["__class"] = "io.apicurio.datamodels.cmd.commands.AbstractSchemaInhCommand";
AbstractSchemaInhCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




